import { action, observable } from 'mobx';

export class PaginationVM {
  @observable props;
  constructor(props) {
    this.props = props;
  }

  @observable paginationRange: any = [1];
  @observable lastPage: number = 1;

  @action.bound usePagination({ totalCount, pageSize, siblingCount, currentPage }) {
    const totalPageCount = this.lastPage;

    // Pages count is determined as siblingCount + firstPage + lastPage + currentPage + 2*DOTS
    const totalPageNumbers = siblingCount + 5;

    /* Case 1: If the number of pages is less than the page numbers we want to show in our
    paginationComponent, we return the range [1..totalPageCount] */
    if (totalPageNumbers >= totalPageCount) {
      this.paginationRange = range(1, totalPageCount);
    }

    /* Calculate left and right sibling index and make sure they are within range 1 and totalPageCount */
    const leftSiblingIndex = Math.max(currentPage - siblingCount, 1);
    const rightSiblingIndex = Math.min(currentPage + siblingCount, totalPageCount);

    /* We do not show dots just when there is just one page number to be inserted between the extremes of sibling 
    and the page limits i.e 1 and totalPageCount. Hence we are using leftSiblingIndex > 2 and rightSiblingIndex < totalPageCount - 2 */
    const shouldShowLeftDots = totalPageCount > 2 * siblingCount + 3 && leftSiblingIndex > 2;
    const shouldShowRightDots = totalPageCount > 2 * siblingCount + 3 && rightSiblingIndex < totalPageCount - 1;

    const firstPageIndex = 1;
    const lastPageIndex = totalPageCount;

    /* Case 2: No left dots to show, but rights dots to be shown */
    if (!shouldShowLeftDots && shouldShowRightDots) {
      const leftItemCount = 1 + 2 * siblingCount;
      const leftRange = range(1, leftItemCount);
      this.paginationRange = [...leftRange, DOTS, totalPageCount];
    }

    /* Case 3: No right dots to show, but left dots to be shown */
    if (shouldShowLeftDots && !shouldShowRightDots) {
      const rightItemCount = 1 + 2 * siblingCount;
      const rightRange = range(totalPageCount - rightItemCount + 1, totalPageCount);
      this.paginationRange = [firstPageIndex, DOTS, ...rightRange];
    }

    /* Case 4: Both left and right dots to be shown */
    if (shouldShowLeftDots && shouldShowRightDots) {
      const middleRange = range(leftSiblingIndex, rightSiblingIndex);
      this.paginationRange = [firstPageIndex, DOTS, ...middleRange, DOTS, lastPageIndex];
    }
  }
}

export const DOTS = '...';

export const range = (start, end) => {
  const length = end - start + 1;
  /* Create an array of certain length and set the elements within it from start value to end value. */
  return Array.from({ length }, (_, idx) => idx + start);
};
